"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagePreview = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const RemoveCircle_1 = require("../../../sharedComponents/RemoveCircle");
const ImagePreview = ({ imageUri, onRemove, removeIcon, }) => {
    return (react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: onRemove },
        react_1.default.createElement(react_native_1.Image, { source: { uri: imageUri }, style: styles.image }),
        react_1.default.createElement(react_native_1.View, { style: styles.removeCircleWrapper },
            react_1.default.createElement(RemoveCircle_1.RemoveCircle, { removeIcon: removeIcon }))));
};
exports.ImagePreview = ImagePreview;
const styles = react_native_1.StyleSheet.create({
    image: {
        borderRadius: 8,
        height: 75,
        marginLeft: 0,
        marginRight: 16,
        marginVertical: 8,
        width: 75,
    },
    removeCircleWrapper: {
        position: 'absolute',
        right: 8,
        top: 0,
    },
});
